<template>
  <div class="pages permissions">
    <div class="container">
      <h1>设备权限清单</h1>
      <p><strong>序言</strong></p>
      <ol>
        <li>
          为保障画世界产品功能实现与安全稳定运行目的，我们可能会申请或使用操作系统的相关权限；
        </li>
        <li>
          为了更好地保障您的知情权，我们通过下列列表将产品可能申请、使用的相关操作系统权限进行说明，您可以根据实际需要对相关权限进行管理和设置。
        </li>
        <li>
          根据着产品的升级，申请、使用操作系统权限的情况可能会发生变动，我们将及时根据这些变动调整本说明，以确保您及时获悉权限申请与使用的情况。
        </li>
        <li>
          请您知悉，为业务与产品的功能和安全需要，我们可能也会使用第三方的软件工具开发包（SDK），这些第三方也可能会申请或使用您的相关操作系统权限。
        </li>
        <li>
          在使用产品过程中，您可能会使用第三方开发或运营的页面或模块（如：H5等），这些第三方也可能因业务功能所必需而申请或使用您的相关操作系统权限。
        </li>
        <li>
          本说明适用于画世界、画世界PRO，具体的适用范围将在以下列表中说明。
        </li>
      </ol>
      <p><strong>安卓操作系统应用权限列表</strong></p>
      <table>
        <thead>
          <tr>
            <th>权限名称</th>
            <th>功能说明</th>
            <th>使用场景与目的</th>
            <th>备注</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              读取/写入外置存储（android.permission.WRITE_EXTERNAL_STORAGE、android.permission.READ_EXTERNAL_STORAGE）
            </td>
            <td>读取和写入SDCard存储数据,获取本地保存随机生成的设备唯一标识</td>
            <td>保存登录设备相关信息，优化账号登录设备管理、读取用户草稿、笔刷、保存的图片、文件等信息</td>
            <td>适用于画世界、画世界PRO</td>
          </tr>
          <tr>
            <td>
              读取/写入相册（android.permission.WRITE_EXTERNAL_STORAGE、android.permission.READ_EXTERNAL_STORAGE）
            </td>
            <td>读取和写入设备相册中的内容</td>
            <td>用于导入相册图片进行绘画创作，或保存作品图片到相册等功能</td>
            <td>适用于画世界、画世界PRO</td>
          </tr>
          <tr>
            <td>相机（android.permission.CAMERA）</td>
            <td>使用相机拍摄照片</td>
            <td>
              用于拍摄照片设置用户头像、创建画题选择封面、创建创作点子选择封面等功能
            </td>
            <td>适用于画世界、画世界PRO</td>
          </tr>
          <tr>
            <td>麦克风 （android.permission.RECORD_AUDIO）</td>
            <td>使用麦克风录制音频</td>
            <td>用于IM私聊发送语音信息、给视频配音</td>
            <td>适用于画世界、画世界PRO</td>
          </tr>
          <tr>
            <td>读取手机/电话状态 （android.permission.READ_PHONE_STATE）</td>
            <td>获取IMEI和MAC等设备识别信息</td>
            <td>用户完成设备绑定，防止账号被盗，优化账号登录设备管理</td>
            <td>适用于画世界、画世界PRO</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "Persissions",
  components: {},
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss">
.permissions {
  .container {
    h1 {
      font-size: 24px;
    }
    
  .container {
    line-height: 1.6em;
    font-size: 14px;
    h3 {
      font-size: 21px;
    }
    a {
      color: #1989fa;
      text-decoration: none;
    }
  }
  table {
    color: #646466;
    font-size: 14px;
    border-spacing: 0;
    border: 1px solid #ebeef5;
    table-layout: fixed;
    width: 100%;
    line-height: normal;
    text-indent: initial;
    text-align: center;
    tr {
      > th {
        padding: 8px 10px;
        border-bottom: 1px solid #d9d9db;
      }
    }
    th,
    td {
      box-sizing: border-box;
      font-weight: normal;
      border-bottom: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
    }
    td {
      padding: 10px 8px;
      vertical-align: middle;
      text-align: center;
      word-wrap: break-word;
    }
  }
  }
}
</style>
